const initalState = {
    authorizedPersons: [{
        name: '',
        surname: '',
        pesel: '',
        id: '',
        document: '',
        countryBirth: '',
        citizenship: '',
        citizenship2Status: false,
        citizenship2: '',
        authorizationEcontract: false,
        authorizationEmail: '',
        authorizationPhone: '',
        idReleaseDate: '',
        idExpirationDate: '',
        address: '',
        maritalStatus: '',
        phone: '',
        email: '',
    }]
}


export const authorizedPersons = (state = initalState.authorizedPersons, action) => { 
    switch (action.type) {
        case 'AUTHORIZED_PERSONS_CHANGE':
            return action.value;      
        default:
            return state
    }
}
